import gql from 'graphql-tag';

export const CREATE_PRICE_CALC = gql`
  mutation createPriceCalculationRule($input: PriceCalculationRuleCreateInput!) {
    createPriceCalculationRule(input: $input) {
      priceCalculationRule {
        id
        propertyId
        type
        billingCycle
        calculateMethod
        dailyPriceType
        customLength
        moveInStart
        moveInEnd
        moveInType
        moveOutType
        moveOutStart
        moveOutEnd
      }
    }
  }
`;

export const UPDATE_PRICE_CALC = gql`
  mutation updatePriceCalculationRule($input: PriceCalculationRuleUpdateInput!) {
    updatePriceCalculationRule(input: $input) {
      priceCalculationRule {
        id
        propertyId
        type
        billingCycle
        calculateMethod
        dailyPriceType
        customLength
        moveInStart
        moveInEnd
        moveInType
        moveOutType
        moveOutStart
        moveOutEnd
      }
    }
  }
`;
